import { render, staticRenderFns } from "./TakeExam.vue?vue&type=template&id=36fa7af0&scoped=true"
import script from "./TakeExam.vue?vue&type=script&lang=js"
export * from "./TakeExam.vue?vue&type=script&lang=js"
import style0 from "./TakeExam.vue?vue&type=style&index=0&id=36fa7af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fa7af0",
  null
  
)

export default component.exports